(function (){
    'use strict';

    angular
        .module('webinar', [
            'ui.router',
            'ui.bootstrap',
            'ngDialog',
            'ui.select',
            'ngSanitize',
            'vAccordion',
            'ngAnimate',
            'ui.footable',
            'daterangepicker',
            'angular.morris',
            'summernote',
            'ui.dateTimeInput',
            'ui.calendar',
            '720kb.datepicker',
            'ngFileUpload',
            'angularFileUpload'
        ]);
})();